import request from 'local_modules/request'
import actions from 'redux/actions'
import { reducers, getState } from 'redux/core'
import { constants, modals } from 'helpers'


const setFetching = (isFetching) => reducers.marketplace.cashierLearnSalePage.setFetching(isFetching)

const setStep = (step) => reducers.marketplace.cashierLearnSalePage.setStep(step)

const setStepData = (stepData) => reducers.marketplace.cashierLearnSalePage.setStepData(stepData)

const clearTotal = () => {
  reducers.marketplace.cashierLearnSalePage.setTotalFetching(true)
  reducers.marketplace.cashierLearnSalePage.setTotal(null)
}

const findSubscriber = ({ groupId, firstName, lastName, middleName, email }) => {
    const { marketplace: { layersNavigation: { tool } } } = getState()

    return request.post(constants.marketplace.learnGroupBooking + `/${groupId}/search`, {
      firstName,
      lastName,
      middleName,
      email,
    })
    .then(({ data }) => data)
    .then((data) => {
      const { status, errormsg } = data || {}

      if (!errormsg) {
        reducers.marketplace.cashierLearnSalePage.setSubscriber({ ...data, groupId })
      }

      return data
    })
    .catch((error) => console.log(error))
}

const fetchGroups = () => {
  const { marketplace: { layersNavigation: { tool } } } = getState()

  return request.get(constants.marketplace.learn + `/${tool}`)
    .then(({ data }) => data)
    .then((data) => {
      if (data && data.length) {
        return data.filter(({ active } = {}) => active)
      }

      return data
    })
    .then((data) => {
      reducers.marketplace.cashierLearnSalePage.setGroups(data)
      return data
    })
    .catch((error) => console.log(error))
}

const fetchTotal = ({ data, groupId }) => {
  const { activeMember, birth, contractNum, email, firstName, gender, id, lastName, middleName } = data

  reducers.marketplace.cashierLearnSalePage.setTotalFetching(true)

  return request.post(constants.marketplace.learnGroupBooking + `/${groupId}/total`, { id })
    .then(({ data }) => data)
    .then(({ status, errormsg, total, accrued, recalcCount, nextMonth }) => {
      if (status === 0) {
        reducers.marketplace.cashierLearnSalePage.setTotal(total)
        reducers.marketplace.cashierLearnSalePage.setAccrued(accrued)
        reducers.marketplace.cashierLearnSalePage.setRecalcCount(recalcCount)
        reducers.marketplace.cashierLearnSalePage.setTotalFetching(false)

        if (nextMonth && nextMonth.learnGroup && nextMonth.learnGroup.currentSchedule && nextMonth.learnGroup.currentSchedule.toMonth) {
          reducers.marketplace.cashierLearnSalePage.setToMonth(nextMonth.learnGroup.currentSchedule.toMonth)
        }
      }
      else if (errormsg) {
        reducers.marketplace.cashierLearnSalePage.setTotalFetching(false)
        actions.modals.open(modals.Dialog, {
          title: 'Ошибка',
          text: errormsg,
        })
      }
    })
    .catch((error) => console.log(error))
}

const handlePayment = ({ subscriberId, groupId }) => {
  actions.ui.showRequestLoader()

  return request.post(constants.marketplace.cashierLearnPay + `/${groupId}`, {
    id: subscriberId,
  })
    .then(({ data }) => data)
    .then((data) => {
      const {
        status,
        errormsg,
      } = data || {}

      actions.ui.hideRequestLoader()

      if (status !== 0 && errormsg) {
        actions.modals.open(modals.Dialog, {
          title: '',
          text: errormsg,
        })
      }
      else {
        reducers.marketplace.cashierLearnSalePage.setTotal(0)
        reducers.marketplace.cashierLearnSalePage.setAccrued(0)
        reducers.marketplace.cashierLearnSalePage.setRecalcCount(0)

        actions.modals.open(modals.Dialog, {
          title: 'Оплачено',
        })
      }

      return data
    })
    .catch((error) => {
      console.log(error)
      actions.ui.hideRequestLoader()
    })
}


export default {
  setFetching,
  setStepData,
  setStep,
  clearTotal,
  fetchTotal,
  fetchGroups,
  findSubscriber,
  handlePayment,
}
